// Einfache Linien-Symbole (24er-Raster, Strich in Schriftfarbe) – dieselben
// wie im Mockup (mockup/js/ikonen.js), selbst gezeichnet, ohne fremde
// Bibliothek. Nur die, die die Apps brauchen; weitere einfach aus dem
// Mockup übernehmen. Die Pfade sind feste Texte aus diesem Code, nie Eingaben.

const PFADE = {
  haus: '<path d="M3 10.5 12 3l9 7.5"/><path d="M5 9v12h14V9"/><path d="M10 21v-6h4v6"/>',
  kamera: '<path d="M4 7h3l2-3h6l2 3h3v13H4z"/><circle cx="12" cy="13" r="4"/>',
  bilder: '<rect x="3" y="5" width="18" height="15" rx="2"/><circle cx="8.5" cy="10" r="1.5"/><path d="M21 16l-5-5-9 9"/>',
  stift: '<path d="M4 20l4-1L19 8l-3-3L5 16z"/><path d="M14 7l3 3"/>',
  mikro: '<rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0"/><path d="M12 18v3"/>',
  lineal: '<path d="M3 17 17 3l4 4L7 21z"/><path d="M7 13l2 2M10 10l2 2M13 7l2 2"/>',
  haken: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
  rechts: '<path d="M9 5l7 7-7 7"/>',
  links: '<path d="M15 5l-7 7 7 7"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  // Seit E3c, S7 (O88): Foto kleiner zoomen
  minus: '<path d="M5 12h14"/>',
  uhr: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
  kalender: '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/>',
  dach: '<path d="M2 13 12 4l10 9"/><path d="M6 10V20h12V10"/><path d="M9 14h6"/>',
  wolke: '<path d="M7 18a5 5 0 1 1 1.1-9.9A6 6 0 0 1 19.5 10 4 4 0 0 1 18 18z"/><path d="M12 12v6M9.5 14.5 12 12l2.5 2.5"/>',
  offline: '<path d="M2 8.5a15 15 0 0 1 20 0M5 12a10 10 0 0 1 14 0M8.5 15.5a5 5 0 0 1 7 0"/><circle cx="12" cy="19" r="1"/><path d="M3 3l18 18"/>',
  ort: '<path d="M12 21s7-6.5 7-12a7 7 0 0 0-14 0c0 5.5 7 12 7 12z"/><circle cx="12" cy="9" r="2.5"/>',
  drohne:
    '<circle cx="12" cy="12" r="2.5"/><path d="M9.8 10.2 6.5 7M14.2 10.2 17.5 7M9.8 13.8 6.5 17M14.2 13.8 17.5 17"/><circle cx="5" cy="5.5" r="2.5"/><circle cx="19" cy="5.5" r="2.5"/><circle cx="5" cy="18.5" r="2.5"/><circle cx="19" cy="18.5" r="2.5"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.5h.01"/>',
  senden: '<path d="M22 2 11 13"/><path d="M22 2 15 22l-4-9-9-4z"/>',
  ebenen: '<path d="M12 3 2 8l10 5 10-5z"/><path d="M2 13l10 5 10-5"/>',
  sonne:
    '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>',
  notiz: '<path d="M4 4h16v12H9l-5 4z"/><path d="M8 9h8M8 12h5"/>',
  frage: '<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .8-1 1.5V14"/><path d="M12 17h.01"/>',
  /** Nur das Fragezeichen, ohne Kreis, in der Mitte des Rasters (seit E3b, O81 a – Gernot: „nur ein Fragezeichen, sauber zentriert“). */
  fragezeichen: '<path d="M8.8 8.6a3.2 3.2 0 1 1 4.6 2.9c-.85.4-1.4 1.1-1.4 2v1"/><path d="M12 18.4h.01"/>',
  teilen: '<path d="M12 3v13M7 8l5-5 5 5"/><path d="M5 12v9h14v-9"/>',
  achtung: '<path d="M12 3 2 20h20z"/><path d="M12 10v4M12 17h.01"/>',
  nutzer: '<circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/>',
  // Seit E2, Schritt 2: Zeichnen auf dem Foto und Foto löschen
  kreis: '<circle cx="12" cy="12" r="8"/>',
  pfeil: '<path d="M5 19 19 5M10 5h9v9"/>',
  zurueck: '<path d="M9 14 4 9l5-5"/><path d="M4 9h10a6 6 0 0 1 0 12h-3"/>',
  muell: '<path d="M4 7h16"/><path d="M9 7V4h6v3"/><path d="M6 7l1 13h10l1-13"/><path d="M10 11v6M14 11v6"/>',
  // Seit E2, Schritt 3: Sprachmemos und das K2-PDF
  abspielen: '<path d="M8 5.5v13l10.5-6.5z"/>',
  pause: '<path d="M9 5.5v13M15 5.5v13"/>',
  stopp: '<rect x="6.5" y="6.5" width="11" height="11" rx="2"/>',
  hochladen: '<path d="M12 16V4M7 9l5-5 5 5"/><path d="M4 16v4h16v-4"/>',
  /** Seit dem Augentest E3b (23.10.2026): „PDF herunterladen“ an der Unterlage. */
  herunterladen: '<path d="M12 4v12M7 11l5 5 5-5"/><path d="M4 16v4h16v-4"/>',
  datei: '<path d="M6 2h9l5 5v15H6z"/><path d="M15 2v5h5M9 13h7M9 17h7"/>',
  // Seit E3: das CRM am Laptop – Seitenleiste, Kisten, Freigabe und Material
  kreuz: '<path d="M6 6l12 12M18 6 6 18"/>',
  menue: '<path d="M4 7h16M4 12h16M4 17h16"/>',
  schild: '<path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/><path d="M8.5 12l2.5 2.5 4.5-4.5"/>',
  gruppe: '<circle cx="9" cy="8" r="3.5"/><path d="M2.5 20a6.5 6.5 0 0 1 13 0"/><path d="M16 4.5a3.5 3.5 0 0 1 0 7M18 14a6 6 0 0 1 3.5 6"/>',
  paket: '<path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5z"/><path d="M3 7.5l9 4.5 9-4.5M12 12v9"/>',
  werkzeug: '<path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.6 2.6-2.4-.6-.6-2.4z"/>',
  blitz: '<path d="M13 2 4 14h7l-1 8 9-12h-7z"/>',
  video: '<rect x="3" y="6" width="13" height="12" rx="2"/><path d="M16 10.5l5-3v9l-5-3"/>',
  funken:
    '<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z"/><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z"/>',
  diagramm: '<path d="M4 20V11M10 20V5M16 20v-6M2 20h20"/>',
  regler:
    '<path d="M4 6h9M17 6h3M4 12h3M11 12h9M4 18h11M19 18h1"/><circle cx="15" cy="6" r="2"/><circle cx="9" cy="12" r="2"/><circle cx="17" cy="18" r="2"/>',
  suche: '<circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/>',
  schloss: '<rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>',
  telefon: '<path d="M5 3h4l2 5-2.5 1.5a11 11 0 0 0 6 6L16 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 5a2 2 0 0 1 2-2z"/>',
  /** Ein Gerät mit der Doku-App (Handy) bzw. dem CRM (Laptop) – Leute und Geräte, seit E3. */
  handy: '<rect x="6.5" y="2.5" width="11" height="19" rx="2.5"/><path d="M10.5 18.5h3"/>',
  laptop: '<rect x="4.5" y="5" width="15" height="10.5" rx="1.5"/><path d="M2 19h20"/>',
  liste: '<path d="M9 6h12M9 12h12M9 18h12"/><circle cx="4.5" cy="6" r="1"/><circle cx="4.5" cy="12" r="1"/><circle cx="4.5" cy="18" r="1"/>',
  drucker: '<path d="M6 9V3h12v6"/><rect x="3" y="9" width="18" height="8" rx="2"/><path d="M7 14h10v7H7z"/>',
  auge: '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>',
  firma: '<path d="M4 21V5l8-3v19"/><path d="M12 9h8v12"/><path d="M3 21h18M8 8h.01M8 12h.01M8 16h.01M16 13h.01M16 17h.01"/>',
  ziel: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1"/>',
  unterschrift: '<path d="M3 17c3-5 5-5 6-1s3 3 5-1 4-4 7 1"/><path d="M3 21h18"/>',
} as const;

export type IkonName = keyof typeof PFADE;

/** Ein Symbol; `groesse` „k“ (klein, 16 px) oder „g“ (groß, 26 px), sonst 20 px. */
export function Ikon({ name, groesse }: { name: IkonName; groesse?: "k" | "g" }) {
  return (
    <svg
      className={`ikon${groesse ? ` ikon-${groesse}` : ""}`}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: PFADE[name] }}
    />
  );
}
